var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 61 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3298 19.6429H24.7766M19.0533 13.9286V25.3571M39.0852 22.5H39.1138M47.6704 16.7857H47.699M26.0615 2.5H34.9388C42.4506 2.5 46.2063 2.5 49.1545 3.92123C51.75 5.17257 53.9066 7.1774 55.3418 9.67311C56.9715 12.5077 57.2391 16.248 57.7745 23.7286L58.4785 33.57C58.8236 38.3954 54.9958 42.5 50.1503 42.5C47.6724 42.5 45.3223 41.4011 43.7361 39.5006L42.6624 38.2143C41.6805 37.0377 41.1894 36.4494 40.6302 35.974C39.4584 34.9777 38.0392 34.314 36.5222 34.0531C35.7985 33.9286 35.0316 33.9286 33.4977 33.9286H27.5027C25.9688 33.9286 25.2018 33.9286 24.478 34.0531C22.9609 34.314 21.542 34.9777 20.3699 35.974C19.8108 36.4494 19.3198 37.0377 18.3378 38.2143L17.2642 39.5006C15.6779 41.4011 13.328 42.5 10.85 42.5C6.00446 42.5 2.17656 38.3954 2.5218 33.57L3.22587 23.7286C3.76107 16.248 4.02864 12.5077 5.65859 9.67311C7.09366 7.1774 9.25025 5.17257 11.8459 3.92123C14.7939 2.5 18.5498 2.5 26.0615 2.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.6cd4f1cbb97f0204664bd4c3766615fd.svg";
export { ForwardRef as ReactComponent };